// extracted by css-extract-rspack-plugin
export default {"fontXs":"fontXs-rlW4MX","linkAction":"linkAction-xhWz8s","footer":"footer-StetxI","footerActions":"footerActions-Uav84R"};